var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Messages",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8106",
    "data-name": "Rectangle 8106",
    width: 24,
    height: 24,
    transform: "translate(430 1786)",
    fill: "#4972f4",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6646",
    "data-name": "Mask Group 6646",
    transform: "translate(-430 -1786)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35253",
    "data-name": "Path 35253",
    d: "M12,1.75C6.477,1.75,2,5.387,2,9.875A7.212,7.212,0,0,0,4.227,14.98a9.938,9.938,0,0,1-2.141,3.742.311.311,0,0,0-.059.34.306.306,0,0,0,.285.187A8.933,8.933,0,0,0,7.8,17.242,11.912,11.912,0,0,0,12,18c5.523,0,10-3.637,10-8.125S17.523,1.75,12,1.75ZM7,11.125a1.25,1.25,0,1,1,1.25-1.25A1.249,1.249,0,0,1,7,11.125Zm5,0a1.25,1.25,0,1,1,1.25-1.25A1.249,1.249,0,0,1,12,11.125Zm5,0a1.25,1.25,0,1,1,1.25-1.25A1.249,1.249,0,0,1,17,11.125Z",
    transform: "translate(430 1787.5)",
    fill: "#4972f4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.314b81e95e894580ae18a830620f20ad.svg";
export { ForwardRef as ReactComponent };